/*<!-- ============================================================================= -->
<!-- Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->*/

$(document).ready(function() {
  $('[data-open-sidebar]').on('click', function() {
    $('.page-sidebar, .page-content').toggleClass('sidebar-open');
    $(this).find('.text').text($('.page-sidebar').hasClass('sidebar-open') ? 'Ocultar Filtros' : 'Mostrar Filtros');
  });

  $(document).on('click', '[data-copy-coupon]', async function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.disabled) return;
    const code = this.dataset.copyCoupon.trim();
    let status = this.parentElement.querySelector('.coupon-copy-status');
    if (!status) {
      status = document.createElement('p');
      status.className = 'coupon-copy-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      this.after(status);
    }
    status.textContent = '';
    this.disabled = true;
    this.setAttribute('aria-busy', 'true');
    try {
      if (!code || !navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(code);
      status.textContent = 'Cupom copiado. Informe o código no checkout.';
    } catch {
      status.textContent = 'Não foi possível copiar. Digite o código ' + code + ' no checkout.';
    } finally {
      this.disabled = false;
      this.removeAttribute('aria-busy');
    }
  });
});


function error_ship_ajax(message, trigger) {
  const container = shippingContainer(trigger);
  if (container) container.querySelector('.erro-shipping').textContent = message;
}

// UPSELL Carrinho
window.upsellSliderInit = function(){
  var upsellCartSlider = new Swiper(".recommend-slider", {
    slidesPerView: "auto",
    spaceBetween: 15,
    slidesPerGroup: 3,
    freeMode: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true
    }
  });
}
function beforeSend() {
  $('#dropdown-cart').addClass('updating-cart');
}
function afterSend() {
  $('#dropdown-cart').removeClass('updating-cart');
}
$(document).on('submit', '.upsell-form', async function(event) {
  event.preventDefault();
  const form = this;
  if (form.dataset.upsellPending === 'true') return;
  const variantData = form.querySelector('[data-json-product]');
  if (variantData) {
    let selectedVariant;
    try {
      const id = form.querySelector('.variantIdAddCart')?.value;
      selectedVariant = JSON.parse(variantData.textContent).find(variant => String(variant.id) === id);
    } catch (_) {}
    if (!selectedVariant?.available) {
      Shopify.showCartError(form, 'Escolha uma opção disponível para adicionar.');
      return;
    }
  }
  const data = new FormData(form);
  const buttons = Array.from(form.querySelectorAll('[type="submit"]'));
  const disabled = buttons.map(button => button.disabled);
  const selectors = Array.from((form.closest('.infoProduct') || form).querySelectorAll('.variants-product-selects select'));
  const selectorDisabled = selectors.map(select => select.disabled);
  let added = false;
  form.dataset.upsellPending = 'true';
  form.setAttribute('aria-busy', 'true');
  buttons.forEach(button => { button.disabled = true; });
  selectors.forEach(select => { select.disabled = true; });
  Shopify.showCartError(form, '');
  beforeSend();
  try {
    await Shopify.enqueueCartMutation(async () => {
      Shopify.cartVersion += 1;
      Shopify.cartStateDirty = true;
      await Shopify.requestCartJSON(Shopify.cartUrl('cart/add.js'), { method: 'POST', body: data });
      added = true;
      const cart = await Shopify.getCart();
      await window.updateCart(cart);
    });
  } catch (error) {
    Shopify.showCartError(form, added ? 'Produto adicionado, mas não foi possível atualizar a visualização. Confira o carrinho antes de adicionar novamente.' : error.message, { cartLink: true });
  } finally {
    delete form.dataset.upsellPending;
    form.removeAttribute('aria-busy');
    buttons.forEach((button, index) => { button.disabled = disabled[index]; });
    selectors.forEach((select, index) => { select.disabled = selectorDisabled[index]; });
    afterSend();
  }
});
$(document).on('change', '.variants-product-selects select', function() {
  const picker = this.closest('.variants-product-selects');
  const info = this.closest('.infoProduct');
  const data = info?.querySelector('[data-json-product]');
  if (!picker || !data) return;

  let variants;
  try { variants = JSON.parse(data.textContent).filter(variant => variant.available); }
  catch (_) { return; }

  const selects = Array.from(picker.querySelectorAll('select'));
  const changedIndex = Number(this.getAttribute('selection-index'));
  const fixedOptions = selects.filter(select => select !== this && select.dataset.upsellHidden === 'true');
  const candidates = variants.filter(variant => fixedOptions.every(select =>
    variant.options[Number(select.getAttribute('selection-index'))] === select.value));
  const validValues = new Set(candidates.map(variant => variant.options[changedIndex]));
  Array.from(this.options).forEach(option => {
    if (option.value) option.disabled = !validValues.has(option.value);
  });
  if (!validValues.has(this.value)) this.value = '';

  const selectedOptions = selects.map(select => select.value);
  const matchingVariant = variants.find(variant =>
    selectedOptions.every((value, index) => value && variant.options[index] === value)
  );
  const variantInput = info.querySelector('.variantIdAddCart');
  const button = info.querySelector('.recommend-btn-add');
  if (variantInput && button) {
    variantInput.value = matchingVariant ? matchingVariant.id : '';
    button.disabled = !matchingVariant;
    button.value = 'ADICIONAR';
  }

  const card = info.closest('.item-recommend');
  if (matchingVariant) {
    card?.querySelectorAll('a[href]').forEach(link => {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('variant', matchingVariant.id);
      link.href = url.toString();
    });
  }
  const colorSelect = picker.querySelector('select[data-name="Cor"]');
  const colorIndex = colorSelect ? Number(colorSelect.getAttribute('selection-index')) : -1;
  const colorLabel = info.querySelector('.color-selected');
  if (colorLabel && colorIndex >= 0) {
    colorLabel.textContent = matchingVariant?.options[colorIndex] || '';
  }
  const image = card?.querySelector('.recommend-item-image');
  if (image) {
    if (!image.dataset.defaultSrc) image.dataset.defaultSrc = image.getAttribute('src');
    const variantImage = matchingVariant?.featured_image?.src;
    const imageSource = variantImage
      ? Shopify.productImageUrl(variantImage, matchingVariant.featured_image.width)
      : Shopify.productImageUrl(image.dataset.defaultSrc);
    image.srcset = imageSource;
    image.src = imageSource;
  }

  const price = info.querySelector('.price');
  if (price && matchingVariant && typeof Shopify.formatMoney === 'function') {
    price.innerHTML = Shopify.formatMoney(matchingVariant.price, window.money_format);
  }

});

// END UPSELL Carrinho

// Cart Shipping

const shippingRequests = new WeakMap();

function shippingContainer(trigger) {
  return trigger?.closest('.cart-drawer__footer__shipping_calculator') ||
    document.querySelector('.cart-drawer__footer__shipping_calculator');
}

function clearShippingEstimate(container) {
  shippingRequests.get(container)?.controller.abort();
  shippingRequests.delete(container);
  container.querySelector('.shipping_options__list').replaceChildren();
  container.querySelector('.cart-drawer__footer__shipping_options').classList.add('hidden');
  container.querySelector('.shipping-display__wrapper').classList.add('hidden');
  container.querySelector('.show-rates-list').setAttribute('aria-expanded', 'false');
  container.querySelector('.recalculate-shipping').classList.add('hidden');
  const button = container.querySelector('.calculate-shipping');
  button.classList.remove('hidden');
  toggleButtonState($(button), false);
  container.removeAttribute('aria-busy');
  container.querySelector('.shipping-status').textContent = '';
  container.querySelector('.erro-shipping').textContent = '';
}

async function shipping_ajax(trigger) {
  const container = shippingContainer(trigger);
  if (!container || shippingRequests.has(container)) return;
  const input = container.querySelector('.zipcode-input');
  const zip = input.value.replace(/\D/g, '');
  const button = container.querySelector('.calculate-shipping');
  const status = container.querySelector('.shipping-status');
  const errorNode = container.querySelector('.erro-shipping');
  clearShippingEstimate(container);
  input.removeAttribute('aria-invalid');
  if (!/^\d{8}$/.test(zip)) {
    input.setAttribute('aria-invalid', 'true');
    errorNode.textContent = 'Informe um CEP válido com 8 números.';
    input.focus();
    return;
  }
  const controller = new AbortController();
  const request = { controller, timedOut: false };
  shippingRequests.set(container, request);
  toggleButtonState($(button), true);
  container.setAttribute('aria-busy', 'true');
  status.textContent = 'Consultando as opções de frete…';
  const timer = setTimeout(() => { request.timedOut = true; controller.abort(); }, 20000);
  const root = window.Shopify?.routes?.root || '/';
  const readJSON = async (url) => {
    const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('Não foi possível consultar o frete. Tente novamente.');
    return response.json();
  };
  const fingerprint = cart => JSON.stringify([cart.currency, cart.total_price,
    cart.items.map(item => [item.key, item.quantity]).sort()]);
  try {
    const cart = await readJSON(root + 'cart.js');
    if (!Array.isArray(cart.items)) throw new Error('Não foi possível conferir o carrinho. Tente novamente.');
    if (!cart.items.length) throw new Error('Adicione um produto ao carrinho para calcular o frete.');
    const address = await readJSON('https://viacep.com.br/ws/' + zip + '/json/');
    if (address.erro || !address.uf) throw new Error('CEP não encontrado. Confira o número e tente novamente.');
    const provinces = { AC: 'Acre', AL: 'Alagoas', AP: 'Amapa', AM: 'Amazonas', BA: 'Bahia', CE: 'Ceara', DF: 'Distrito Federal', ES: 'Espirito Santo', GO: 'Goias', MA: 'Maranhao', MT: 'Mato Grosso', MS: 'Mato Grosso do Sul', MG: 'Minas Gerais', PA: 'Para', PB: 'Paraiba', PR: 'Parana', PE: 'Pernambuco', PI: 'Piaui', RJ: 'Rio de Janeiro', RN: 'Rio Grande do Norte', RS: 'Rio Grande do Sul', RO: 'Rondonia', RR: 'Roraima', SC: 'Santa Catarina', SP: 'Sao Paulo', SE: 'Sergipe', TO: 'Tocantins' };
    const params = new URLSearchParams({
      'shipping_address[zip]': zip,
      'shipping_address[country]': 'Brazil',
      'shipping_address[province]': provinces[address.uf] || address.estado || address.uf
    });
    const data = await readJSON(root + 'cart/shipping_rates.json?' + params);
    if (!Array.isArray(data.shipping_rates)) throw new Error('Resposta de frete inválida. Tente novamente.');
    const latestCart = await readJSON(root + 'cart.js');
    if (!Array.isArray(latestCart.items) || fingerprint(cart) !== fingerprint(latestCart)) {
      throw new Error('O carrinho mudou. Calcule o frete novamente para os produtos atuais.');
    }
    if (!container.isConnected || shippingRequests.get(container) !== request || input.value.replace(/\D/g, '') !== zip) return;
    const list = container.querySelector('.shipping_options__list');
    const money = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: cart.currency || 'BRL' });
    const fragment = document.createDocumentFragment();
    data.shipping_rates.forEach((rate, index) => {
      const price = typeof rate.price === 'number' ? rate.price : Number(rate.price);
      if (rate.price == null || rate.price === '' || !Number.isFinite(price) || price < 0 || typeof rate.name !== 'string') {
        throw new Error('Uma tarifa veio incompleta. Tente consultar novamente.');
      }
      const formattedPrice = price === 0 ? 'Grátis' : money.format(price);
      const days = Array.isArray(rate.delivery_days) ? rate.delivery_days.filter(day => day != null && Number.isFinite(Number(day)) && Number(day) > 0).map(Number) : [];
      const maxDays = days.length ? Math.max(...days) : null;
      const delivery = maxDays ? 'Em até ' + maxDays + (maxDays === 1 ? ' dia útil' : ' dias úteis') : '';
      const li = document.createElement('li');
      li.className = 'filters-group__list__item';
      const label = document.createElement('label');
      label.className = 'filters-checkbox';
      const radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'shipping_estimate';
      radio.value = String(index);
      radio.dataset.name = rate.name;
      radio.dataset.formattedPrice = formattedPrice;
      radio.dataset.delivery = delivery;
      const check = document.createElement('span');
      check.className = 'check';
      check.setAttribute('aria-hidden', 'true');
      const text = document.createElement('span');
      text.className = 'text';
      text.textContent = rate.name + ' · ' + formattedPrice + (delivery ? ' (' + delivery + ')' : '');
      label.append(radio, check, text);
      li.append(label);
      fragment.append(li);
    });
    list.replaceChildren(fragment);
    container.querySelector('.cart-drawer__footer__shipping_options').classList.remove('hidden');
    status.textContent = data.shipping_rates.length ? 'Estimativas disponíveis para os produtos do carrinho.' : 'Nenhuma opção de frete foi encontrada para este CEP. Confira o endereço ou consulte o atendimento.';
  } catch (error) {
    if (shippingRequests.get(container) !== request || !container.isConnected) return;
    status.textContent = '';
    errorNode.textContent = request.timedOut ? 'A consulta demorou mais que o esperado. Tente novamente.' :
      (error.name === 'AbortError' ? 'A consulta foi interrompida. Tente novamente.' :
       error instanceof SyntaxError || error instanceof TypeError ? 'Não foi possível consultar o frete. Verifique sua conexão e tente novamente.' : error.message);
  } finally {
    clearTimeout(timer);
    if (shippingRequests.get(container) === request) {
      shippingRequests.delete(container);
      container.removeAttribute('aria-busy');
      toggleButtonState($(button), false);
    }
  }
}

function select_ship(selected) {
  const input = selected[0];
  const container = shippingContainer(input);
  const focusedOnRate = container.querySelector('.shipping_options__list').contains(document.activeElement);
  container.querySelector('.shipping-rate-name').textContent = input.dataset.name;
  container.querySelector('.shipping-display.value').textContent = input.dataset.formattedPrice;
  container.querySelector('.shipping-display__wrapper').classList.remove('hidden');
  container.querySelector('.shipping-rate-name').classList.remove('hidden');
  container.querySelector('.cart-drawer__footer__shipping_options').classList.add('hidden');
  container.querySelector('.show-rates-list').setAttribute('aria-expanded', 'false');
  container.querySelector('.calculate-shipping').classList.add('hidden');
  container.querySelector('.recalculate-shipping').classList.remove('hidden');
  if (focusedOnRate) container.querySelector('.show-rates-list').focus();
}

function toggleButtonState(button, isLoading) {
  button.toggleClass('is-loading', isLoading).prop('disabled', isLoading).attr('aria-busy', String(isLoading));
}

$(document).on('click', '.calculate-shipping', function (event) {
  event.preventDefault();
  shipping_ajax(this);
});
$(document).on('keydown', '.zipcode-input', function (event) {
  if (event.key === 'Enter') { event.preventDefault(); shipping_ajax(this); }
});
$(document).on('input', '.zipcode-input', function () {
  clearShippingEstimate(shippingContainer(this));
  this.removeAttribute('aria-invalid');
});
$(document).on('click', '.recalculate-shipping', function (event) {
  event.preventDefault();
  const container = shippingContainer(this);
  clearShippingEstimate(container);
  container.querySelector('.zipcode-input').focus();
});
$(document).on('change', 'input[name="shipping_estimate"]', function () { select_ship($(this)); });
$(document).on('click', '.show-rates-list', function (event) {
  event.preventDefault();
  shippingContainer(this).querySelector('.cart-drawer__footer__shipping_options').classList.remove('hidden');
  this.setAttribute('aria-expanded', 'true');
});
document.addEventListener('cart-update', () => {
  document.querySelectorAll('.cart-drawer__footer__shipping_calculator').forEach(clearShippingEstimate);
});

  // END CART Shipping

window.handleize = function (input) {
  return String(input ?? '')
    // 1. Decompose accented letters into letter + diacritic mark
    .normalize("NFD")
    // 2. Toss out the diacritic marks
    .replace(/[\u0300-\u036f]/g, "")
    // 3. Lower-case everything
    .toLowerCase()
    // 4. Trim leading/trailing space
    .trim()
    // 5. Remove everything except letters, numbers, spaces, and dashes
    .replace(/[^a-z0-9\s-]/g, "")
    // 6. Replace groups of whitespace with a single dash
    .replace(/\s+/g, "-")
    // 7. Collapse multiple dashes (in case input had "--" etc.)
    .replace(/-+/g, "-");
}


function formatCep(value) {
    return value
        .replace(/\D/g, '')
        .slice(0, 8)
        .replace(/^(\d{5})(\d{0,3})$/, (_, p1, p2) => p2 ? `${p1}-${p2}` : p1);
}

function isValidCep(value) {
    return /^\d{5}-\d{3}$/.test(value);
}

function formatPhone(value) {
    return value
        .replace(/\D/g, '')
        .slice(0, 11)
        .replace(/^(\d{2})(\d{0,5})(\d{0,4})$/, (_, ddd, p1, p2) => p2 ? `(${ddd}) ${p1}-${p2}` : p1 ? `(${ddd}) ${p1}` : `(${ddd}`);
}

function applyMask(target, formatter) {
    // Salva o estado do cursor para evitar o salto para o final
    const start = target.selectionStart;
    const previousLength = target.value.length;

    target.value = formatter(target.value);

    // Reposiciona o cursor adequadamente
    const lengthDiff = target.value.length - previousLength;
    const newPosition = Math.max(0, start + lengthDiff);
    target.setSelectionRange(newPosition, newPosition);
}

document.addEventListener('input', ({ target }) => {
    if (target.matches('.zipcode-input') || target.matches('.cep-calculo-frete')) {
        applyMask(target, formatCep);
    } else if (target.matches('.contact-phone')) {
        applyMask(target, formatPhone);
    }
});

document.addEventListener('focusout', ({ target }) => {
    if (!target.matches('.zipcode-input')) return;

    if (target.value && !isValidCep(target.value)) {
        error_ship_ajax('CEP inválido', target);
    }
});
